{{#each this}}
  <li class='delivery__item'>
    <div class='delivery__item--box'>{{name}}</div>
    <p class='delivery__item--description'>
      {{description}}
    </p>
  </li>
{{/each}}